var FaqItem = function() {

	this.init = function() {

		this.itemslide();
	}

	this.itemslide = function() {


		$('body').on('click', '.question', function() {
			$(this).toggleClass("open");

			$(this).next(".content").slideToggle();
			
			if ( $(this).hasClass('open') ) {
				$('html, body').animate({
					scrollTop: $(window).scrollTop() + $(this).scrollTop() + ($(this).next().find('p').height() + 25 )
				});
			}

		});


	}
	return this.init();
}